import type { ReactNode } from "react";

interface SectionProps {
  title: string;
  icon?: ReactNode;
  count?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  flush?: boolean;
}

export function Section({
  title,
  icon,
  count,
  actions,
  children,
  flush,
}: SectionProps) {
  return (
    <div className="section">
      <div className="section__header">
        <h3 className="section__title">
          {icon}
          <span className="section__title-text">{title}</span>
          {count !== undefined && <span className="section__count">{count}</span>}
        </h3>
        {actions && <div className="section__actions">{actions}</div>}
      </div>
      <div className={`section__body${flush ? " section__body--flush" : ""}`}>
        {children}
      </div>
    </div>
  );
}
